export default __webpack_public_path__ + "static/media/placeholder_dummy-2014-store03-mobile-de.dab4351c.png";